import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Spring, animated } from 'react-spring';
import classNames from 'classnames';

class BaseModal extends Component {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
    this.el.classList.add('modal-container');
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    const {
      maxWidth = 852,
      maxHeight = 'none',
      minWidth = 360,
      minHeight = 'none',
      className,
    } = this.props;

    const classes = classNames({
      modal: true,
      [className]: !!className,
    });

    return ReactDOM.createPortal(
      <Fragment>
        <div style={{ position: 'relative', zIndex: 0 }} />
        <div style={{ pointerEvents: 'auto', position: 'relative', zIndex: 0 }}>
          <Spring
            native
            from={{
              opacity: 0,
            }}
            to={{
              opacity: 1,
            }}
            config={{ tension: 210, friction: 20 }}
          >
            {bgStyles => (
              <animated.div className="modal-bg" style={bgStyles}>
                <div style={{ width: '100%', height: '100%' }} />
                <Spring
                  native
                  from={{
                    transform: 'scale3d(0.5, 0.5, 1) translate3d(0, 200px, 0)',
                  }}
                  to={{
                    transform: 'scale3d(1, 1, 1) translate3d(0, 0, 0)',
                  }}
                  config={{ tension: 210, friction: 20 }}
                >
                  {styles => (
                    <animated.div
                      className={classes}
                      style={{
                        ...styles,
                        maxWidth,
                        maxHeight,
                        minWidth,
                        minHeight,
                      }}
                    >
                      {this.props.children}
                    </animated.div>
                  )}
                </Spring>
              </animated.div>
            )}
          </Spring>
        </div>
      </Fragment>,
      this.el
    );
  }
}

export default BaseModal;
